/*
    Handwai Platform - User Roles
*/
export default {
    SUPER_ADMIN: 'Super-Admin',
    ADMIN: 'Admin',
    ANALYST: 'Analyst',
    CALCULATOR: 'Calculator'
};
